
    export interface TempInvoiceFinderProject extends more.EntityAPIResultExtended {
        ref_ev_project_status: ProjectStatus;
        ev_project_name: string;
        ref_artistic_period: ArtisticPeriod;
        date_from: Date;
        date_to: Date;
    }

    export interface TempInvoiceEditorProject extends more.EntityAPIResultExtended {
        ev_project_name: string;
        EL_ev_booking_ev_project: Array<TempInvoiceEditorBooking>;
    }

    export interface ProjectStatus extends more.EntityAPIResultExtended {
        code: string;
        coloration: more.EntityAPIColor;
    }

    export interface ArtisticPeriod extends more.EntityAPIResultExtended {
        description: string;
    }

    export interface ExistingMusicianPlanningResponse extends more.EntityAPIResultExtended {
        hasExistingMusicianPlanning: boolean;
        isAcademyService: boolean;
        replacementReason: string;
        replacementFor: string;
        adjacentProject: TempInvoiceEditorProject;
        is_staying_for_adjacent_project: boolean;
        musicianPlanning: more.EntityAPIResultExtended;
        bookings: Array<TempInvoiceEditorBooking>;
        programs: Array<TempInvoiceEditorProgram>;
        opus: Array<TempInvoiceEditorProgram>;
        arrival_from: string;
        return_back_to: string;
        is_hotel_needed: boolean;
        date_arrival: Date;
        date_departure: Date;
        residence: number;
        position: number;
        ref_associate: TempInvoiceTemp;
        ref_functional_group: TempInvoiceFunctionalMainGroup;
        ref_functional_sub_group: TempInvoiceFunctionalSubGroup;
        is_substitute_confirmed: boolean;
        is_substitute_canceled: boolean;
        is_input_confirmed: boolean;
        ref_ev_project?: TempInvoiceFinderProject;
        maxDaysAfterEnd?: number;

    }

    export interface TempInvoiceEditorProgram extends more.EntityAPIResultExtended {
        gDisp_1: string;
    }

    export interface TempInvoiceEditorBooking extends more.EntityAPIResultExtended {
        ev_booking_name: string;
        date_start: Date;
        date_end: Date;
        ref_ev_activity_status: TempInvoiceEditorActivityStatus;
    }

    export interface TempInvoiceEditorActivityStatus extends more.EntityAPIResultExtended {
        description: string;
        coloration: more.EntityAPIColor;
    }

    export interface TempInvoiceTemp extends more.EntityAPIResultExtended {
        gDisp_Name_Firstname: string;
        c_city: string;
        ref_country: TempInvoiceCountry;
        ref_person: TempInvoicePerson;
    }

    export interface TempInvoicePerson extends more.EntityAPIResultExtended {
        ref_telecomm_mobile_01: { telecom_code: string };
        ref_telecomm_phone_01: { telecom_code: string };
        ref_telecomm_email_01: { telecom_code: string };
    }

    export interface TempInvoiceCountry extends more.EntityAPIResultExtended {
        description: string;
    }

    export interface TempInvoiceFunctionalMainGroup extends more.EntityAPIResultExtended {
        description: string;
        coloration: more.EntityAPIColor;
        EL_functional_sub_group_functional_group: Array<TempInvoiceFunctionalSubGroup>;
    }

    export interface TempInvoiceFunctionalSubGroup extends more.EntityAPIResultExtended {
        description: string;
        coloration: more.EntityAPIColor;
    }

    export interface TempInvoicePresetData {
        temp: TempInvoiceTemp;
        functionalMainGroup: TempInvoiceFunctionalMainGroup;
        functionalSubGroup: TempInvoiceFunctionalSubGroup;
        residence?: TempInvoiceResidenceString;
        arrival_from?: string;
        return_back_to?: string;
        is_hotel_needed?: boolean;
        date_arrival?: Date;
        date_departure?: Date;
    }

    export type TempInvoiceResidenceString = "berlin" | "germany" | "international";

    export const MusicianPlanning = "musican_planning_ev_project"

    export const TempInvoiceResidence: Record<number, TempInvoiceResidenceString> = {
        1: "berlin",
        2: "germany",
        3: "international"
    }
